import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*
 * Created on Wed Jul 18 2018
 */


import { CRUTransportLayer } from '../CRUTransportLayer';
import { CompetitorProductConverter, CompetitorProductDTOConverter, jsonConversions, ProductInfoFilterConverterImpl, ResultWithOverviewConverterImpl } from '@logio/common-be-fe';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import { Inject } from '@logio/typescript-ioc';
import logger from '../../logger';
/**
 * @author BPo
 */

export var CompetitorProductLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(CompetitorProductLayer, _CRUTransportLayer);

  function CompetitorProductLayer() {
    _classCallCheck(this, CompetitorProductLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorProductLayer).call(this, CONSTANTS.API.ENDPOINTS.COMPETITOR_PRODUCT));
  }

  _createClass(CompetitorProductLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
    /**
     * Fletches competitors products
     */

  }, {
    key: "getCompetitorProductsFullTextSearch",
    value: function getCompetitorProductsFullTextSearch(overview) {
      var resultWithOverviewConverter = new ResultWithOverviewConverterImpl(this.competitorProductDTOConverter, new ProductInfoFilterConverterImpl());
      return api("".concat(CONSTANTS.API.ENDPOINTS.DATA_PAIRING).concat(CONSTANTS.API.ENDPOINTS.FULL_TEXT_SEARCH_UNPAIRED)).post({
        overview: overview
      }, {
        responseType: 'json'
      }).then(function (response) {
        return resultWithOverviewConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Sets ignore / unignore flag on competitor products
     */

  }, {
    key: "ignoreUnignore",
    value: function ignoreUnignore(competitorProductIds) {
      var ignoreUnignorePromise = api("".concat(CONSTANTS.API.ENDPOINTS.COMPETITOR_PRODUCT).concat(CONSTANTS.API.ENDPOINTS.IGNORE_UNIGNORE)).post({
        competitorProductIds: competitorProductIds
      }, {
        responseType: 'json'
      }).then(function (response) {
        return response;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return ignoreUnignorePromise;
    }
  }]);

  return CompetitorProductLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", CompetitorProductConverter)], CompetitorProductLayer.prototype, "converter", void 0);

__decorate([Inject, __metadata("design:type", CompetitorProductDTOConverter)], CompetitorProductLayer.prototype, "competitorProductDTOConverter", void 0);